import ExportFirestoreData from '../../components/admin/ExportFirestoreData';

const AdminDashboard = () => {
  return (
    <div>
      <h1>Admin Dashboard</h1>

      <p>
        Manage company information and export records.
      </p>

      <ExportFirestoreData />
    </div>
  );
};

export default AdminDashboard;